<script lang="ts">
  import Select from '../ui/Select.svelte';
  import Tabs from '../ui/Tabs.svelte';
  import BoardSettings from './BoardSettings.svelte';
  import type { GameConfig, RoundPace } from '../../shared/config';

  interface Props {
    config: GameConfig;
    editable?: boolean;
    change: (patch: Partial<GameConfig>) => void;
  }
  let { config, editable = true, change }: Props = $props();

  const PACES: readonly { value: RoundPace; label: string }[] = [
    { value: 'live', label: 'Live' },
    { value: 'async', label: 'Turns' },
  ];
</script>

<Tabs
  value={config.pace}
  items={PACES}
  label="pace"
  align="center"
  disabled={!editable}
  onchange={(pace) => change({ pace })}
>
  {#snippet children(pace)}
    <div class="settings settings-grid board-settings">
      <label for="game-variant">Mode</label>
      <!-- Chaos power-ups need one shared clock, so Turns rooms play Classic (validateConfig). -->
      <Select
        id="game-variant"
        aria-label="game mode"
        value={pace === 'async' ? 'classic' : config.variant}
        disabled={!editable || pace === 'async'}
        onchange={(value) => change({ variant: value })}
        options={[
          { value: 'classic', label: 'Classic' },
          { value: 'chaos', label: 'Chaos' },
        ]}
      />
      <BoardSettings {config} {editable} {change} />
      <!-- Only Live rooms run a ready check; Turns rooms always open at once. -->
      <div class="start-automatically">
        <label for="start-automatically">Start Automatically</label>
        <input
          id="start-automatically"
          type="checkbox"
          aria-label="start automatically"
          checked={pace === 'async' || config.startAutomatically}
          disabled={!editable || pace === 'async'}
          onchange={(event) => change({ startAutomatically: event.currentTarget.checked })}
        />
      </div>
    </div>
  {/snippet}
</Tabs>

<style>
  /* The checkbox sits on the label's line, right-aligned, at every width. */
  .start-automatically {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .start-automatically input {
    margin: 0;
  }
</style>
